import React from 'react'
import ViewScoreSectionalForTeacher from '../components/MT_Score/ViewScoreSectionalForTeacher'
import ScoreViewHeaderForTeacher from '../components/MT_Score/ScoreViewHeaderForTeacher'

const MtScoreViewScoreSectionalForTeacher = () => {
  return (
    <>
    <ScoreViewHeaderForTeacher />
    <ViewScoreSectionalForTeacher />
    </>
  )
}

export default MtScoreViewScoreSectionalForTeacher